<template lang="pug">
.form-edit-room
  .ui.very.relaxed.grid
    .row.two.column.stackable
      .column
        h3 房间信息
        .ui.form
          .three.fields
            .field
              label 房号
              input.disabled(v-model='form.no', type='text', disabled)
            .field
              label 楼层
              input(v-model='form.category', type='text')
            .field
              label 名称
              input(v-model='form.name', type='text')
          .two.fields
            .field
              label 月租价格
              input(v-model='form.price_month', type='text')
            .field
              label 日租价格
              input(v-model='form.price_day', type='text')
          .ui.field(v-if='$config.logic.lezhu_meter')
            label 乐住电表编号 (例: 333000100)
            input(v-model='form.lezhu_meter_id', type='number')
          .ui.field
            label 备注
            textarea(v-model='form.note', rows='1')
          .ui.field
            el-checkbox(v-model='form.avaliable', label='房间可用')

        br
        br

        auto-edit-table(
          v-if='$permission.has("basic.modify.rooms.history_notes")',
          :defines='$defines.history_notes', :form-meta='{room_id:room._id}', title='房屋记录',
          :data='room.history_notes || []', :detail-view='false', :button-add='true'
        )
          h3(slot='title') 房屋记录

      .column
        h3.with-actions(v-if='$permission.has("basic.modify.rooms.properties")')
          span 物品清单
          .ui.buttons.actions
            .ui.basic.icon.button(@click='dialogVisiable = true')
              i.icon.pencil.themed.text
        room-properties(:properties='form.properties')

    .row
      .column
        .ui.button.themed(@click='submit') 确认修改
        .ui.button(@click='cancel') 取消

    dialog-edit-properties(:properties.sync='form.properties', :visible.sync='dialogVisiable', @exit='dialogVisiable = false')
</template>

<script>
import { MakeForm } from '../../utils'
import { AutoTable, AutoEditTable } from '../auto'
import RoomProperties from '../mixed/RoomProperties.vue'
import DialogEditProperties from './DialogEditProperties.vue'

export default {
  name: 'form-edit-room',
  props: ['no'],
  components: {
    AutoTable,
    AutoEditTable,
    DialogEditProperties,
    RoomProperties,
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    properties() {
      return this.$store.getters.properties
    },
  },
  data() {
    return {
      dialogVisiable: false,
      form: {
        category: '',
        price_day: '',
        price_month: '',
        note: '',
        avaliable: true,
        name: '',
        lezhu_meter_id: null,
        properties: [],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.form.no = this.room.no
      this.form.category = this.room.category
      this.form.price_day = this.room.price_day
      this.form.price_month = this.room.price_month
      this.form.note = this.room.note
      this.form.avaliable = this.room.avaliable
      this.form.lezhu_meter_id = this.room.lezhu_meter_id
      this.form.name = this.room.name
      this.form.properties = JSON.parse(JSON.stringify(this.room.properties || []))
    },
    cancel() {
      this.$router.back()
    },
    submit_form: MakeForm({
      type: 'put',
      url() { return `rooms/${this.room._id}` },
      confirm: '确定保存修改？',
      payload() {
        return {
          category: this.form.category,
          price_day: this.form.price_day,
          price_month: this.form.price_month,
          note: this.form.note,
          avaliable: this.form.avaliable,
          lezhu_meter_id: this.form.lezhu_meter_id,
          name: this.form.name,
          properties: this.form.properties,
        }
      },
      loadOnSuccess: 'rooms',
      $afterSuccess() {
        this.$router.back()
      },
    }),
    submit() {
      this.submit_form()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormEditRoom.vue?4d9f5e97